export const USER_COUNTRY_CA = "CA";
export const NO_LOCATION_MESSAGE = "Enter your Postal Code, City or Province";
export const NO_LOCATION_MESSAGE_US = "Enter your Zip Code, City or State";
export const CANT_FIND_LOCATION_MESSAGE =
  "It looks like we can't find your location. Tell us where you are so we can find stores near you!";
